<template>
  <div class="company-page">
    <!-- 导航栏 -->
    <header class="header" :class="{ 'header-scroll': isScrolled }">
      <div class="header-content">
        <div class="logo">
          <h1>快推帮</h1>
          <span class="company-name">杭州点顺科技有限公司</span>
        </div>
        <nav class="nav">
          <a href="#home" @click="scrollToSection('home')" :class="{ 'active': activeSection === 'home' }">首页</a>
          <a href="#product" @click="scrollToSection('product')" :class="{ 'active': activeSection === 'product' }">产品介绍</a>
          <a href="#about" @click="scrollToSection('about')" :class="{ 'active': activeSection === 'about' }">关于我们</a>
          <a href="#agreement" @click="scrollToSection('agreement')" :class="{ 'active': activeSection === 'agreement' }">用户协议</a>
          <a href="#privacy" @click="scrollToSection('privacy')" :class="{ 'active': activeSection === 'privacy' }">隐私政策</a>
          <a href="#contact" @click="scrollToSection('contact')" :class="{ 'active': activeSection === 'contact' }">联系我们</a>
        </nav>
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <!-- 移动端菜单 -->
      <div class="mobile-nav" :class="{ 'mobile-nav-active': mobileMenuActive }">
        <a href="#home" @click="scrollToSection('home')" :class="{ 'active': activeSection === 'home' }">首页</a>
        <a href="#product" @click="scrollToSection('product')" :class="{ 'active': activeSection === 'product' }">产品介绍</a>
        <a href="#about" @click="scrollToSection('about')" :class="{ 'active': activeSection === 'about' }">关于我们</a>
        <a href="#agreement" @click="scrollToSection('agreement')" :class="{ 'active': activeSection === 'agreement' }">用户协议</a>
        <a href="#privacy" @click="scrollToSection('privacy')" :class="{ 'active': activeSection === 'privacy' }">隐私政策</a>
        <a href="#contact" @click="scrollToSection('contact')" :class="{ 'active': activeSection === 'contact' }">联系我们</a>
      </div>
    </header>

    <!-- 首页大图区域 -->
    <section id="home" class="hero-section">
      <img :src="require('@/assets/home_bg.png')" alt="快推帮 - 杭州点顺科技有限公司" class="hero-image">
      <!-- <div class="hero-overlay">
        <div class="hero-content">
          <h1 class="hero-title">快推帮</h1>
          <p class="hero-subtitle">高效推广，助力成长</p>
          <p class="hero-desc">专业的移动营销推广平台</p>
        </div>
      </div> -->
    </section>

    <!-- 产品介绍区域 -->
    <section id="product" class="section product-section">
      <div class="container">
        <h2 class="section-title">产品介绍</h2>
        <div class="product-content">
          <div class="product-intro">
            <h3>快推帮APP</h3>
            <p class="product-desc">
              快推帮是由杭州点顺科技有限公司开发的一款专业移动营销推广平台。我们致力于为用户提供高效、便捷的推广服务，帮助企业和个人实现业务增长。
            </p>
            <div class="features">
              <div class="feature-item">
                <div class="feature-icon">📱</div>
                <h4>移动优先</h4>
                <p>专为移动端优化，随时随地轻松推广</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">🚀</div>
                <h4>高效便捷</h4>
                <p>简单易用的操作界面，快速上手</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">📊</div>
                <h4>数据分析</h4>
                <p>实时数据统计，效果一目了然</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">🔒</div>
                <h4>安全可靠</h4>
                <p>多重安全保障，保护用户隐私</p>
              </div>
            </div>
          </div>
          <div class="app-download">
            <h3>立即下载</h3>
            <div class="qr-code-box">
              <img src="https://yiqimeng.oss-cn-hangzhou.aliyuncs.com/kuaituibang_app.png" alt="快推帮APP下载" class="qr-code">
              <p>扫码下载快推帮APP</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们区域 -->
    <section id="about" class="section about-section">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <div class="about-content">
          <h3>杭州点顺科技有限公司</h3>
          <p>
            杭州点顺科技有限公司成立于2022年，是一家专注于移动互联网技术研发与服务的创新型企业。公司位于美丽的杭州西湖区，拥有一支经验丰富、充满活力的技术团队。
          </p>
          <p>
            我们的使命是通过技术创新，为用户提供更优质的产品和服务。快推帮APP是我们精心打造的核心产品，旨在帮助更多的企业和个人实现营销推广目标。
          </p>
          <div class="company-values">
            <div class="value-item">
              <h4>创新</h4>
              <p>持续技术创新，引领行业发展</p>
            </div>
            <div class="value-item">
              <h4>专业</h4>
              <p>专业团队，专业服务</p>
            </div>
            <div class="value-item">
              <h4>共赢</h4>
              <p>与客户共同成长，实现双赢</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 用户协议区域 -->
    <section id="agreement" class="section agreement-section">
      <div class="container">
        <h2 class="section-title">用户协议</h2>
        <div class="agreement-content">
          <p class="update-time">更新时间：2025年1月1日 | 生效时间：2025年1月1日</p>
          
          <h3>尊敬的用户：</h3>
          <p>在您成为快推帮注册用户，使用快推帮提供的服务之前，请您认真阅读《快推帮用户协议》（以下简称"协议"或"本协议"），更好地了解我们所提供的服务以及您享有的权利和承担的义务。您一旦开始使用快推帮服务，即表示您已经确认并接受了本协议中的全部条款。</p>
          <p>本协议系由您（以下简称"用户"或"您"）与杭州点顺科技有限公司（以下简称"快推帮"或"我们"）所订立的相关权利义务规范。请您在注册、使用快推帮之前，认真阅读以下条款。</p>
          
          <h3>一、信息收集与使用</h3>
          <p><strong>1.个人信息的收集</strong></p>
          <p>为了向您提供更好的服务，快推帮会收集、存储和使用您的个人信息，包括但不限于您的姓名、手机号码、电子邮件地址、地理位置、设备信息、IP地址、日志信息等。如果您不提供这些信息，可能无法使用快推帮的服务或无法达到提供服务的最佳效果。</p>
          
          <p><strong>2.个人信息的使用</strong></p>
          <p>快推帮仅会在以下情形使用您的个人信息：</p>
          <p>（1）向您提供所请求的服务；</p>
          <p>（2）为了改善和优化快推帮的服务而使用；</p>
          <p>（3）根据法律法规、行政命令、司法裁定等法律程序的要求；</p>
          <p>（4）为保护快推帮、快推帮用户或公众的合法权益。</p>
          
          <h3>二、信息的共享与披露</h3>
          <p>除以下情形外，快推帮不会向任何第三方共享、披露您的个人信息：</p>
          <p>（1）事先获得您的明确同意或授权；</p>
          <p>（2）根据法律法规、行政命令、司法裁定等法律程序的要求；</p>
          <p>（3）为了保护快推帮、快推帮用户或公众的合法权益；</p>
          <p>（4）根据法律规定或与合并、收购、重组等相关的交易中需要向第三方披露。</p>
          
          <h3>三、信息的安全保护</h3>
          <p>快推帮会采取安全保护措施，保护您的个人信息不被未经授权的访问、使用或泄漏。如果您发现自己的个人信息泄露或遭受到未经授权的访问，请立即与快推帮联系。</p>
          
          <h3>四、未成年人信息的保护</h3>
          <p>1、我们非常重视未成年人的信息保护。我们建议未满18周岁的未成年人应当在父母或监护人的指导下使用快推帮相关服务，并建议未成年人在提交个人信息之前，应事先取得父母或监护人的同意和指导。</p>
          <p>2、对于已经取得父母或监护人同意的未成年人，我们会根据国家相关法律法规的规定及本用户协议的约定对其个人信息进行保护。</p>
          <p>3、对于未成年人的个人信息，我们仅会在法律法规允许、父母或监护人明确同意或保护未成年人所必要的情况下收集、使用、存储、传输或披露。</p>
          
          <h3>五、数据安全措施</h3>
          <p>为了保障您的信息安全，我们将采取一系列安全措施来保护您的个人信息，包括但不限于：</p>
          <p>1.合理布置信息安全组织结构和管理制度，建立完善的内部管理制度和操作流程，保障信息安全；</p>
          <p>2.采用严格的信息安全技术措施，防止您的个人信息被未经授权的访问、使用或泄露，例如加密技术、匿名化处理等；</p>
          <p>3.采取物理、电子和行政等多重措施，保护您的个人信息不被意外或非法的情况下毁损、丢失、篡改或泄露；</p>
          <p>4.仅授权访问个人信息的员工、合作伙伴或代理商可以访问您的个人信息，并且他们必须遵守相关保密协议和责任制度；</p>
          <p>5.在信息安全事件发生后，我们将及时启动应急预案，防止安全事件扩大，并在规定时间内将事件结果告知您。</p>
          
          <h3>六、服务说明</h3>
          <p><strong>1、信息发布规范</strong></p>
          <p>通过快推帮平台，您必须按照快推帮的规则发布信息。并且所发布之信息不得含有如下内容：</p>
          <p>1）反对宪法所确定的基本原则的；</p>
          <p>2）危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的；</p>
          <p>3）损害国家荣誉和利益的；</p>
          <p>4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>5）散布谣言，扰乱社会秩序的；</p>
          <p>6）宣扬淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>7）侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>8）含有法律、行政法规禁止的其他内容的。</p>
          
          <p><strong>2、禁止行为</strong></p>
          <p>在使用快推帮服务的过程中，您必须被禁止从事下列行为：</p>
          <p>1）发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容；</p>
          <p>2）制造虚假身份以误导、欺骗他人；</p>
          <p>3）进行危害计算机网络安全的行为；</p>
          <p>4）未经快推帮书面授权，出售、出租、出借、散布、转让服务；</p>
          <p>5）其他违反使用快推帮平台服务规则的行为。</p>
          
          <p><strong>3、用户承诺</strong></p>
          <p>在使用快推帮服务过程中，您需承诺遵守以下约定：</p>
          <p>1）遵守国家法律、法规等规范文件及快推帮平台各项规则；</p>
          <p>2）不发布国家禁止发布的信息；</p>
          <p>3）不对快推帮平台上的任何数据作商业性使用；</p>
          <p>4）不干预或试图干预快推帮平台的正常运作。</p>
          
          <p><strong>4、违约责任</strong></p>
          <p>未按本协议约定使用快推帮平台服务的，您将承担以下后果：</p>
          <p>1）快推帮有权依据本协议的约定，做出相应处理或终止向您提供服务；</p>
          <p>2）若您的行为涉嫌违法违规，快推帮有权采取相应措施，包括但不限于屏蔽、删除侵权信息、停止提供服务；</p>
          <p>3）因您违反本协议致使第三方遭受损害的，均应由您自行承担全部责任；</p>
          <p>4）因您违反有关法律法规使快推帮遭受任何损失的，您应承担全部赔偿责任。</p>
          
          <h3>七、付费服务</h3>
          <p>1、快推帮可能提供付费服务或增值服务，您可根据自身需求选择购买会员或相关服务。</p>
          <p>2、付费服务一经购买，不得退款，您不得以任何理由要求快推帮退还全部或部分费用。</p>
          <p>3、在开通付费服务后，若您存在违反本协议的行为，快推帮有权提前终止服务，并且不退还费用。</p>
          
          <h3>八、协议修改</h3>
          <p>我们保留随时修改本协议的权利。我们会在APP内发布任何修改后的用户协议。如果您在协议修改生效后继续使用我们的服务，则视为您已经接受该协议的修改。</p>
          
          <h3>九、联系我们</h3>
          <p>如果您对本用户协议有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
          <p>电子邮箱：154156165@qq.com</p>
          <p>公司地址：浙江省杭州市西湖区西溪街道文二路188号16幢446室</p>
          <p>我们会尽快回复您的询问，并尽力解决您的问题。</p>
          
          <h3>十、法律适用与争议解决</h3>
          <p>本协议受中华人民共和国法律管辖。如发生任何争议，应通过友好协商解决。如果协商无果，则应提交杭州仲裁委员会进行仲裁。</p>
          <p>如果本协议中的任何条款被认为无效或不可执行，则该条款应被删除，但不影响其余条款的有效性。</p>
          
          <p style="margin-top: 30px;">感谢您使用快推帮服务！</p>
        </div>
      </div>
    </section>

    <!-- 隐私政策区域 -->
    <section id="privacy" class="section privacy-section">
      <div class="container">
        <h2 class="section-title">隐私政策</h2>
        <div class="privacy-content">
          <p class="update-time">发布时间：2025年1月1日 | 生效时间：2025年1月1日 | 更新时间：2025年1月1日</p>
          
          <h3>引言</h3>
          <p>快推帮是一款专注于为用户提供移动营销推广服务的平台。我们致力于为您提供一个便捷、高效的推广信息发布与管理平台，助您实现业务增长。快推帮非常重视用户的隐私，非常感谢您的信任，选择快推帮为您提供服务。</p>
          <p>为更好地保障用户隐私，快推帮特别从如下几方面对您在使用快推帮服务过程中，我们是如何收集、使用、存储、分享您的个人信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式做出如下具体说明。</p>
          <p><strong>请您在使用快推帮所有产品及服务前，仔细阅读本隐私政策，并确定了解我们对您个人信息的收集、处理等规则。如您不同意本隐私政策的任何条款，请立即停止注册及使用快推帮相关产品或服务。</strong></p>
          
          <h3>一、快推帮可能收集的信息内容</h3>
          <p><strong>快推帮收集的个人信息主要包括您注册时提供的个人信息以及在使用快推帮相关产品及服务过程中授权快推帮获取的信息以及第三方分享有关您的信息。个人信息指您的姓名、证件号码、联系方式、住址、账号密码、财产状况、行踪轨迹等，以电子或者其他方式记录的能够单独或者与其他信息结合识别您身份或者反映您活动情况的各种信息。</strong></p>
          
          <p><strong>1.1 主动提供的信息</strong></p>
          <p>（1）您在注册或使用快推帮产品及服务过程中，您主动提供的姓名、证件号码、手机号、电子邮箱信息。您选择使用第三方账号登录时，快推帮会收集您微信、QQ、微博、AppleID的第三方账号、图像、昵称信息。</p>
          <p>（2）您在使用快推帮产品及服务过程中上传的姓名、住址、证件号码、手机号、电子邮箱信息。</p>
          <p>（3）您在参加快推帮举办的线上及线下活动过程中提供的姓名、手机号、微信、QQ信息。</p>
          
          <p><strong>1.2 我们如何收集和使用个人信息</strong></p>
          <p>（1）<strong>开展内部数据分析和研究，改善我们的产品或服务</strong></p>
          <p>我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集的数据可能包括SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。</p>
          
          <p>（2）<strong>注册、登录、认证</strong></p>
          <p>当您注册、登录快推帮及相关服务时，您可以通过手机号创建账号，并且您可以完善相关的网络身份识别信息（头像、昵称、密码），收集这些信息是为了帮助您完成注册。您还可以根据自身需求选择填写性别、生日、地区及个人介绍来完善您的信息。</p>
          <p>您也可以使用第三方账号登录并使用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于与快推帮账号绑定。</p>
          
          <p>（3）<strong>设备信息与日志信息</strong></p>
          <p>为了保障软件服务及您的账号的安全、服务运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备名称、设备配置、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP地址、WLAN接入点、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。</p>
          
          <p>（4）<strong>消息通知</strong></p>
          <p>您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（例如：邮箱、联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、争议处理用途。</p>
          
          <p><strong>1.3 征得授权同意的例外</strong></p>
          <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息不必事先征得您的授权同意：</p>
          <p>（1）与我们履行法律法规规定的义务相关的；</p>
          <p>（2）与国家安全、国防安全直接相关的；</p>
          <p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>（4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>（5）出于维护您或他人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
          <p>（6）您自行向社会公众公开的个人信息；</p>
          <p>（7）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
          
          <h3>二、快推帮收集信息的使用规则</h3>
          <p><strong>2.1 快推帮收集信息可能用于如下用途</strong></p>
          <p>（1）您提供的个人信息将用于登录及使用产品及服务过程中的身份验证、客户服务、安全防范、存档和备份用途，以确定您身份的唯一性，并保障快推帮向您提供服务的安全性。</p>
          <p>（2）改善快推帮提供产品及服务过程，满足用户个人需求，提升用户体验。</p>
          <p>（3）在法律规定范围内，快推帮可能将本平台收集的信息提供给其他关联方，或将您的信息用于分析设计新产品及服务。</p>
          <p>（4）经您同意的其他用途。</p>
          
          <p><strong>2.2 快推帮收集信息的使用规则</strong></p>
          <p>（1）快推帮会采取一切合理可行的安全防护措施保护用户信息，防止用户信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。</p>
          <p>（2）收集您的个人信息后，快推帮将通过技术手段对数据进行去标识化处理，使您的信息无法被识别主体。</p>
          <p>（3）您同意在未注销账户或进行特别设置的情况下，快推帮在您账户有效期间内按照本隐私政策约定持续使用您的信息。</p>
          
          <h3>三、快推帮如何共享、转让、公开披露您的个人信息</h3>
          <p><strong>3.1 共享</strong></p>
          <p>我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
          <p>（1）在获取您明确同意的情况下，我们会与合作伙伴及软件提供商、服务提供商第三方共享您的个人信息。</p>
          <p>（2）我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
          <p>（3）为维护快推帮、快推帮的关联方或合作伙伴、您或其他快推帮用户或社会公众利益、财产或安全免遭损害。</p>
          
          <p><strong>3.2 转让</strong></p>
          <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
          <p>（1）事先获得您明确的同意或授权；</p>
          <p>（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</p>
          <p>（3）在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束。</p>
          
          <p><strong>3.3 公开披露</strong></p>
          <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
          <p>（1）您同意或授权快推帮披露的；</p>
          <p>（2）您使用共享功能的；</p>
          <p>（3）根据法律、法规的要求、强制性的行政执法或司法要求。</p>
          
          <h3>四、快推帮如何使用Cookie和同类技术</h3>
          <p>Cookie和同类技术是互联网中普遍使用的技术。当您使用快推帮及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们使用Cookie和同类技术主要为了实现以下功能或服务：</p>
          <p>（1）保障产品与服务的安全、高效运转；</p>
          <p>（2）帮助您获得更轻松的访问体验；</p>
          <p>（3）您可以在浏览器设置功能中进行相应的数据清除操作。</p>
          
          <h3>五、快推帮如何保护和保存您的个人信息</h3>
          <p><strong>5.1 存储地点</strong></p>
          <p>我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。</p>
          
          <p><strong>5.2 存储期限</strong></p>
          <p>我们仅在为提供快推帮及服务之目的所必需的期间内保留您的个人信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>
          
          <p><strong>5.3 数据安全技术措施</strong></p>
          <p>（1）快推帮会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改、避免数据的损坏或丢失。</p>
          <p>（2）快推帮提供的网络服务采取通过https等方式提供浏览服务，保障用户数据在传输过程中的安全。</p>
          <p>（3）快推帮将采取严格的数据访问权限控制和多重身份认证技术保护个人信息。</p>
          
          <p><strong>5.4 安全事件处置</strong></p>
          <p>如发生安全事件，快推帮将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、已采取或将要采取的处置措施、您可自主防范和降低风险的建议等。</p>
          
          <h3>六、您如何管理个人信息</h3>
          <p>快推帮非常重视您对个人信息的保护，并在法律允许的范围内尽全力保护您对个人信息访问、更正、删除以及撤回同意的权利。您的权利包括：</p>
          <p>（1）<strong>访问、修改、删除您的个人信息</strong></p>
          <p>您有权访问、修改、删除您的个人信息。您可以通过快推帮的具体产品或服务"设置"中进行操作。</p>
          
          <p>（2）<strong>改变您授权同意的范围或撤回您的授权</strong></p>
          <p>您有权改变您授权同意的范围或撤回您的授权。您可以通过删除信息、关闭设备功能、或在相应产品或服务的"设置"中进行隐私设置。</p>
          
          <p>（3）<strong>注销账户</strong></p>
          <p>您可以通过快推帮的具体产品或服务"设置"中所公布的注销方式申请注销相关账户。您注销账户后，快推帮将停止为您提供与账号相关的产品或服务功能，并将删除或匿名化处理您的个人信息。</p>
          
          <h3>七、未成年人信息的保护</h3>
          <p>快推帮非常重视对未成年人个人信息的保护。若您是14周岁以下的未成年人，在使用我们的产品或服务前，应事先取得您家长或法定监护人的书面同意。快推帮将根据未成年人相关法律规定保障其合法权益不受侵害。</p>
          <p>快推帮鼓励监护人指导未成年人使用快推帮的产品和服务，并建议未成年人鼓励其监护人阅读本政策。</p>
          
          <h3>八、隐私政策的修订和更新</h3>
          <p>随着快推帮的不断发展以及不断提升服务质量及产品品质的宗旨，本隐私政策也会随之修订、更新。我们不会在未经您同意的情况下，限制或减少您依据本隐私政策享有的权利。</p>
          <p>对于重大变更，我们将通过邮件、短信、在浏览页面做出特别提示等方式进行通知说明。若您继续使用快推帮产品和服务，即表示您同意接受修订、更新后隐私政策的约束。</p>
          
          <h3>九、如何联系我们</h3>
          <p>如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请发送邮件至154156165@qq.com与我们进行联系。</p>
          <p>我们将在收到您反馈意见后的7个工作日内给予回复。</p>
          
          <p><strong>平台运营主体名称：</strong>杭州点顺科技有限公司</p>
          <p><strong>注册地址：</strong>浙江省杭州市西湖区西溪街道文二路188号16幢446室</p>
          <p><strong>联系邮箱：</strong>154156165@qq.com</p>
          
          <p style="margin-top: 30px;">感谢您信任并使用快推帮！</p>
        </div>
      </div>
    </section>

    <!-- 联系我们区域 -->
    <section id="contact" class="section contact-section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <div class="contact-item">
              <h4>📍 公司地址</h4>
              <p>浙江省杭州市西湖区西溪街道文二路188号16幢446室</p>
            </div>
            <div class="contact-item">
              <h4>📧 联系邮箱</h4>
              <p>154156165@qq.com</p>
            </div>
            <div class="contact-item">
              <h4>🏢 公司名称</h4>
              <p>杭州点顺科技有限公司</p>
            </div>
            <div class="contact-item">
              <h4>📱 产品名称</h4>
              <p>快推帮APP</p>
            </div>
          </div>
          <div class="contact-qr">
            <h4>扫码下载APP</h4>
            <img src="https://yiqimeng.oss-cn-hangzhou.aliyuncs.com/kuaituibang_app.png" alt="快推帮APP下载" class="contact-qr-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 底部备案信息 -->
    <footer class="footer">
      <div class="footer-content">
        <!-- 公司信息 -->
        <div class="company-info">
          <p><strong>杭州点顺科技有限公司</strong></p>
          <p>地址：浙江省杭州市西湖区西溪街道文二路188号16幢446室</p>
          <p>邮箱：154156165@qq.com</p>
        </div>

        <!-- 备案信息 -->
        <div class="beian-info">
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener">
              浙ICP备2022035642号-11
            </a>
          </p>
          <!-- <p>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjhENjZFQzQyQTczMTFFM0E3MDFFRjZGNEVDQTA1NTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjhENjZFQzUyQTczMTFFM0E3MDFFRjZGNEVDQTA1NTUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGOEQ2NkVDMjJBNzMxMUUzQTcwMUVGNkY0RUNBMDU1NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGOEQ2NkVDMzJBNzMxMUUzQTcwMUVGNkY0RUNBMDU1NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pqvsq8IAAAAaSURBVHjaYvz//z8DsYARpBgJMAZNTgYBBRgAdmQC2bAEOYQAAAAASUVORK5CYII=" alt="公安备案" style="vertical-align: middle; margin-right: 5px;">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener">
              浙公网安备 XXXXXXXXXXXXXX号
            </a>
          </p> -->
          <p class="copyright">©2025 杭州点顺科技有限公司 版权所有</p>
        </div>

        <!-- 二维码区域 -->
        <div class="qrcode-section">
          <div class="qrcode-item">
            <div class="qrcode-box">
              <img src="https://yiqimeng.oss-cn-hangzhou.aliyuncs.com/kuaituibang_app.png" alt="APP下载二维码" class="qrcode-img">
            </div>
            <p class="qrcode-label">APP下载</p>
          </div>
          <!-- <div class="qrcode-item">
            <div class="qrcode-box">
              <img src="https://via.placeholder.com/150x150/409eff/ffffff?text=%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1" alt="企业微信二维码" class="qrcode-img">
            </div>
            <p class="qrcode-label">企业微信</p>
          </div> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      isScrolled: false,
      mobileMenuActive: false,
      activeSection: 'home',
      sections: ['home', 'product', 'about', 'agreement', 'privacy', 'contact']
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
      this.updateActiveSection()
    },
    updateActiveSection() {
      const scrollPosition = window.scrollY + 100 // 100px offset for header
      
      for (let i = this.sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(this.sections[i])
        if (section) {
          const sectionTop = section.offsetTop - 70
          if (scrollPosition >= sectionTop) {
            this.activeSection = this.sections[i]
            break
          }
        }
      }
    },
    toggleMobileMenu() {
      this.mobileMenuActive = !this.mobileMenuActive
    },
    scrollToSection(sectionId) {
      this.mobileMenuActive = false
      const element = document.getElementById(sectionId)
      if (element) {
        const headerHeight = 70
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.company-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 导航栏 */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.header-scroll {
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}

.logo h1 {
  font-size: 28px;
  color: #1867FE;
  margin: 0;
  font-weight: bold;
}

.company-name {
  font-size: 12px;
  color: #666;
  display: block;
  margin-top: 2px;
}

.nav {
  display: flex;
  gap: 30px;
}

.nav a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s;
  padding: 5px 0;
  border-bottom: 2px solid transparent;
  position: relative;
}

.nav a:hover {
  color: #1867FE;
  border-bottom-color: #1867FE;
}

.nav a.active {
  color: #1867FE;
  border-bottom-color: #1867FE;
  font-weight: 600;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
}

.mobile-menu-btn span {
  width: 25px;
  height: 3px;
  background-color: #333;
  transition: all 0.3s;
}

.mobile-nav {
  display: none;
  flex-direction: column;
  background-color: #fff;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.mobile-nav a {
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #eee;
  transition: all 0.3s;
  position: relative;
}

.mobile-nav a:hover {
  background-color: #f5f7fa;
  color: #1867FE;
}

.mobile-nav a.active {
  background-color: #e8f2ff;
  color: #1867FE;
  font-weight: 600;
  border-left: 3px solid #1867FE;
}

.mobile-nav-active {
  max-height: 400px;
}

/* 首页大图区域 */
.hero-section {
  position: relative;
  width: 100%;
  height: auto;
  margin-top: 70px;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  text-align: center;
  color: #fff;
  padding: 20px;
}

.hero-title {
  font-size: 64px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}

.hero-subtitle {
  font-size: 32px;
  margin-bottom: 10px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

.hero-desc {
  font-size: 20px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

/* 通用section样式 */
.section {
  padding: 80px 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 40px;
  color: #333;
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  padding-bottom: 20px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(to right, #1867FE, #4A90E2);
  border-radius: 2px;
}

/* 产品介绍区域 */
.product-section {
  background-color: #fff;
}

.product-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: start;
}

.product-intro h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
}

.product-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 40px;
}

.features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.feature-item h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.feature-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.app-download {
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 30px;
  border-radius: 15px;
  color: #fff;
}

.app-download h3 {
  font-size: 24px;
  margin-bottom: 25px;
}

.qr-code-box {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  display: inline-block;
}

.qr-code {
  width: 200px;
  height: 200px;
  display: block;
  margin-bottom: 15px;
}

.qr-code-box p {
  color: #333;
  font-size: 14px;
  margin: 0;
}

/* 关于我们区域 */
.about-section {
  background-color: #f8f9fa;
}

.about-content h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 25px;
}

.about-content p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.company-values {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.value-item {
  background: #fff;
  padding: 40px 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
}

.value-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.value-item h4 {
  font-size: 22px;
  color: #1867FE;
  margin-bottom: 15px;
}

.value-item p {
  font-size: 14px;
  color: #666;
}

/* 用户协议和隐私政策区域 */
.agreement-section,
.privacy-section {
  background-color: #fff;
}

.agreement-content,
.privacy-content {
  max-width: 900px;
  margin: 0 auto;
}

.update-time {
  color: #999;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: right;
}

.agreement-content h3,
.privacy-content h3 {
  font-size: 22px;
  color: #333;
  margin: 30px 0 15px 0;
}

.agreement-content p,
.privacy-content p {
  font-size: 15px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 12px;
}

/* 联系我们区域 */
.contact-section {
  background-color: #f8f9fa;
}

.contact-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.contact-item {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.contact-item h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

.contact-item p {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

.contact-qr {
  text-align: center;
  background: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.contact-qr h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}

.contact-qr-img {
  width: 200px;
  height: 200px;
}

/* 底部备案信息 */
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 40px 20px 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 40px;
}

.qrcode-section {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.qrcode-item {
  text-align: center;
}

.qrcode-box {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.qrcode-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.qrcode-img {
  width: 120px;
  height: 120px;
  display: block;
}

.qrcode-label {
  font-size: 14px;
  color: #fff;
  margin: 0;
  font-weight: 500;
}

.company-info,
.beian-info {
  flex: 1;
  min-width: 250px;
}

.company-info p,
.beian-info p {
  margin: 10px 0;
  font-size: 14px;
  line-height: 1.6;
}

.company-info strong {
  font-size: 16px;
}

.beian-info a {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s;
}

.beian-info a:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.copyright {
  margin-top: 20px;
  padding-top: 20px;
  font-size: 13px;
  color: #bbb;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-nav {
    display: flex;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 20px;
  }

  .hero-desc {
    font-size: 16px;
  }

  .section {
    padding: 50px 20px;
  }

  .section-title {
    font-size: 28px;
  }

  .product-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .features {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .company-values {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .contact-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .contact-info {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .qrcode-section {
    justify-content: center;
    gap: 20px;
    width: 100%;
  }

  .qrcode-img {
    width: 100px;
    height: 100px;
  }

  .company-info,
  .beian-info {
    text-align: center;
  }
}
</style>
